export default __webpack_public_path__ + "static/media/vd-screenshot-histogram.4405acb2.png";